import { Database, Megaphone, Camera, PhoneCall, Handshake } from "lucide-react";
import { ESTRUTURA } from "../content";
import { Reveal } from "../lib/motion";

const ICONS = [Database, Megaphone, Camera, PhoneCall, Handshake];

export const Estrutura = () => (
  <section
    id="estrutura"
    data-testid="estrutura-section"
    className="on-light bg-creme text-tinta py-20 md:py-28"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="label-caps text-azul mb-5">Estrutura dedicada</p>
        <h2
          data-testid="estrutura-title"
          className="headline text-3xl sm:text-4xl lg:text-5xl max-w-3xl"
        >
          Uma operação inteira dedicada ao seu negócio
        </h2>
      </Reveal>

      <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
        {ESTRUTURA.map((card, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={card.title} delay={i * 0.08} className="h-full">
              <article
                data-testid={`estrutura-card-${i}`}
                className="h-full bg-creme border border-creamline p-6 flex flex-col hover:border-azul transition-colors duration-200"
              >
                <span className="w-11 h-11 flex items-center justify-center bg-azul text-creme">
                  <Icon className="w-5 h-5" aria-hidden="true" />
                </span>
                <h3 className="mt-6 font-sora font-bold text-base tracking-[-0.025em] leading-snug">
                  {card.title}
                </h3>
                <p className="mt-2.5 text-sm text-mutedlight leading-relaxed">{card.desc}</p>
              </article>
            </Reveal>
          );
        })}
      </div>

      <Reveal delay={0.15}>
        <p
          data-testid="estrutura-closing"
          className="mt-12 md:mt-14 font-sora font-bold text-xl md:text-2xl tracking-[-0.035em] max-w-3xl"
        >
          Você não contrata um serviço isolado.{" "}
          <span className="text-azul">Contrata um time que opera como parte da sua empresa.</span>
        </p>
      </Reveal>
    </div>
  </section>
);
